// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Ticket$ReactHooksTemplate = require("./ticket.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var TicketHeader$ReactHooksTemplate = require("./ticketHeader.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var TicketCategory$ReactHooksTemplate = require("./ticketCategory.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var TicketHeadersApi$ReactHooksTemplate = require("./TicketHeadersApi.res.js");
var TicketStatusColors$ReactHooksTemplate = require("./TicketStatusColors.res.js");
var TicketHeadersClient$ReactHooksTemplate = require("./TicketHeadersClient.res.js");

function fetchTickets(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/tickets", (function (param) {
                return Json_decode.field("tickets", (function (param) {
                              return Json_decode.list(Ticket$ReactHooksTemplate.decode, param);
                            }), param);
              }));
}

function fetchTicketWorkers(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/recovery_agents", (function (param) {
                return Json_decode.field("recovery_agents", (function (param) {
                              return Json_decode.list(Ticket$ReactHooksTemplate.Assignee.decode, param);
                            }), param);
              }));
}

function create(ticket) {
  return {
          ticket: ticket,
          enabled: false
        };
}

function ticket(t) {
  return t.ticket;
}

function ticketId(t) {
  return Ticket$ReactHooksTemplate.id(t.ticket);
}

function enabled(t) {
  return t.enabled;
}

function forceStatus(enabled, t) {
  return {
          ticket: t.ticket,
          enabled: enabled
        };
}

function toggleStatus(t) {
  return {
          ticket: t.ticket,
          enabled: !t.enabled
        };
}

var TicketStatus = {
  create: create,
  ticket: ticket,
  ticketId: ticketId,
  enabled: enabled,
  forceStatus: forceStatus,
  toggleStatus: toggleStatus
};

var emptyForm = {
  ticketStatuses: /* [] */0,
  assignees: /* [] */0,
  selected: undefined,
  selectAll: false
};

function reducer(state, action) {
  if (state.loading) {
    if (typeof action === "object" && action.TAG === "DisplayList") {
      var init = state.form;
      return {
              loading: false,
              toggleFilter: state.toggleFilter,
              scope: state.scope,
              form: {
                ticketStatuses: action._0,
                assignees: action._1,
                selected: init.selected,
                selectAll: init.selectAll
              }
            };
    }
    return {
            loading: state.loading,
            toggleFilter: state.toggleFilter,
            scope: state.scope,
            form: emptyForm
          };
  }
  if (typeof action !== "object") {
    switch (action) {
      case "ToggleSelectAll" :
          var partial_arg = !state.form.selectAll;
          var ticketStatuses = List.map((function (param) {
                  return forceStatus(partial_arg, param);
                }), state.form.ticketStatuses);
          var init$1 = state.form;
          return {
                  loading: state.loading,
                  toggleFilter: state.toggleFilter,
                  scope: state.scope,
                  form: {
                    ticketStatuses: ticketStatuses,
                    assignees: init$1.assignees,
                    selected: init$1.selected,
                    selectAll: !state.form.selectAll
                  }
                };
      case "ToggleFilter" :
          return {
                  loading: state.loading,
                  toggleFilter: !state.toggleFilter,
                  scope: state.scope,
                  form: state.form
                };
      case "Loading" :
          return {
                  loading: true,
                  toggleFilter: state.toggleFilter,
                  scope: state.scope,
                  form: state.form
                };
      
    }
  } else {
    switch (action.TAG) {
      case "DisplayList" :
          var init$2 = state.form;
          return {
                  loading: state.loading,
                  toggleFilter: state.toggleFilter,
                  scope: state.scope,
                  form: {
                    ticketStatuses: action._0,
                    assignees: action._1,
                    selected: init$2.selected,
                    selectAll: init$2.selectAll
                  }
                };
      case "UpdateAssignee" :
          var init$3 = state.form;
          return {
                  loading: state.loading,
                  toggleFilter: state.toggleFilter,
                  scope: state.scope,
                  form: {
                    ticketStatuses: init$3.ticketStatuses,
                    assignees: init$3.assignees,
                    selected: action._0,
                    selectAll: init$3.selectAll
                  }
                };
      case "ToggleTicketStatus" :
          var ticketStatus = action._0;
          var ticketStatuses$1 = List.map((function (x) {
                  if (Caml_obj.equal(ticketStatus, x)) {
                    return toggleStatus(x);
                  } else {
                    return x;
                  }
                }), state.form.ticketStatuses);
          var init$4 = state.form;
          return {
                  loading: state.loading,
                  toggleFilter: state.toggleFilter,
                  scope: state.scope,
                  form: {
                    ticketStatuses: ticketStatuses$1,
                    assignees: init$4.assignees,
                    selected: init$4.selected,
                    selectAll: init$4.selectAll
                  }
                };
      case "UpdateViewFilter" :
          return {
                  loading: state.loading,
                  toggleFilter: state.toggleFilter,
                  scope: action._0,
                  form: state.form
                };
      
    }
  }
}

function assignTicket(assignee, tickets) {
  var params = {};
  params["assignee_id"] = Ticket$ReactHooksTemplate.Assignee.id(assignee);
  var ticketIds = Belt_List.map(tickets, Ticket$ReactHooksTemplate.id);
  params["ids"] = Json_encode.list((function (prim) {
          return prim;
        }), ticketIds);
  var ticket = {};
  ticket["ticket"] = params;
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/tickets/assign", ticket);
}

function scopeFromString(scope) {
  var match = scope.toLowerCase();
  switch (match) {
    case "assigned" :
        return "Assigned";
    case "unassigned" :
        return "Unassigned";
    default:
      return "All";
  }
}

function scopeToString(x) {
  switch (x) {
    case "All" :
        return "all";
    case "Assigned" :
        return "assigned";
    case "Unassigned" :
        return "unassigned";
    
  }
}

function fromString(status) {
  var match = status.toLowerCase();
  switch (match) {
    case "closed" :
        return "Closed";
    case "open" :
        return "Open";
    case "parked" :
        return "Parked";
    case "resolved" :
        return "Resolved";
    default:
      return "All";
  }
}

function toString(x) {
  switch (x) {
    case "All" :
        return "all";
    case "Open" :
        return "open";
    case "Parked" :
        return "parked";
    case "Resolved" :
        return "resolved";
    case "Closed" :
        return "closed";
    
  }
}

var WorkflowStatus = {
  fromString: fromString,
  toString: toString
};

function fetchTicketDetails(param) {
  return Js_promise.then_((function (tickets) {
                return Js_promise.then_((function (workers) {
                              var ticketStatuses = List.map(create, tickets);
                              return Promise.resolve([
                                          ticketStatuses,
                                          workers
                                        ]);
                            }), fetchTicketWorkers());
              }), fetchTickets());
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

function s(prim) {
  return prim;
}

function TicketManager(props) {
  var scope = props.scope;
  var initialState_scope = scopeFromString(scope);
  var initialState = {
    loading: true,
    toggleFilter: false,
    scope: initialState_scope,
    form: emptyForm
  };
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return {
                sortedColumn: "created_at",
                sortingOrder: "desc"
              };
      });
  var setSortingInfo = match$1[1];
  var sortingInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$2[1];
  var pageInfo = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setOpenSortModal = match$3[1];
  var openSortModal = match$3[0];
  var match$4 = React.useState(function (param) {
        return /* [] */0;
      });
  var setTicketHeaders = match$4[1];
  var ticketHeaders = match$4[0];
  var match$5 = React.useState(function (param) {
        return [];
      });
  var setColumnOrder = match$5[1];
  var columnOrder = match$5[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "sortedCol");
  var sortedColumn = x$1 !== undefined && x$1 !== "" ? x$1 : "";
  var x$2 = Js_dict.get(queryParams, "sortOrder");
  var sortingOrder = x$2 !== undefined && x$2 !== "" ? x$2 : "";
  var s = Js_dict.get(queryParams, "status");
  var workflowStatus = s !== undefined && s !== "" ? fromString(s) : "All";
  var workflowStatusParam = toString(workflowStatus);
  var fetchKey = String(currentPage) + "-" + workflowStatusParam + "-" + scope + "-" + sortedColumn + "-" + sortingOrder;
  var fetchTickets = function (param) {
    var pageNumber = String(currentPage);
    var sortedCol = sortingInfo.sortedColumn === "" ? sortedColumn : sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder === "" ? sortingOrder : sortingInfo.sortingOrder;
    var url = sortedCol !== "" && sortOrder !== "" ? "/api/v1/tickets?page=" + pageNumber + "&scope=" + scope + "&status=" + workflowStatusParam + "&sortedCol=" + sortedCol + "&sortOrder=" + sortOrder : "/api/v1/tickets?page=" + pageNumber + "&scope=" + scope + "&status=" + workflowStatusParam;
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var tickets = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("tickets", (function (param) {
                                            return Json_decode.list(Ticket$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              tickets,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var fetchTicketHeaders = function (param) {
    Js_promise.then_((function (param) {
            var cols = param[1];
            var headers = param[0];
            Curry._1(setTicketHeaders, (function (param) {
                    return headers;
                  }));
            Curry._1(setColumnOrder, (function (param) {
                    return cols;
                  }));
            return Promise.resolve();
          }), TicketHeadersClient$ReactHooksTemplate.fetchOverview());
  };
  var fetchTicketWorkers = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/recovery_agents", (function (param) {
                  return Json_decode.field("recovery_agents", (function (param) {
                                return Json_decode.list(Ticket$ReactHooksTemplate.Assignee.decode, param);
                              }), param);
                }));
  };
  var fetchTicketDetails = function (param) {
    return Js_promise.then_((function (param) {
                  var pageInfo = param[1];
                  var tickets = param[0];
                  return Js_promise.then_((function (workers) {
                                return Js_promise.then_((function (tickets) {
                                              var ticketStatuses = List.map(create, tickets);
                                              return Promise.resolve([
                                                          [
                                                            ticketStatuses,
                                                            workers
                                                          ],
                                                          pageInfo
                                                        ]);
                                            }), tickets);
                              }), fetchTicketWorkers());
                }), fetchTickets());
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "Loading");
          fetchTicketHeaders();
          Js_promise.then_((function (param) {
                  var ticketDetails = param[0];
                  var pageInfo = param[1];
                  var perPage = pageInfo[1];
                  var total = pageInfo[0];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  perPage: perPage
                                };
                        }));
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "DisplayList",
                                  _0: ticketDetails[0],
                                  _1: ticketDetails[1]
                                }));
                }), fetchTicketDetails());
        }), [fetchKey]);
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "Loading");
    Js_promise.then_((function (param) {
            var ticketDetails = param[0];
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            return Promise.resolve(Curry._1(dispatch, {
                            TAG: "DisplayList",
                            _0: ticketDetails[0],
                            _1: ticketDetails[1]
                          }));
          }), fetchTicketDetails());
  };
  var handlePageChange = function (pageNumber) {
    var scopeParam = scopeToString(state.scope);
    var pageNumber$1 = String(pageNumber);
    var sortedCol = sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder;
    RescriptReactRouter.push("/tickets/manage/" + scopeParam + "?page=" + pageNumber$1 + "&status=" + workflowStatusParam + "&sortedCol=" + sortedCol + "&sortOrder=" + sortOrder);
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  var handleWorkflowStatusChange = function (nextStatus, _event) {
    var scopeParam = scopeToString(state.scope);
    var statusParam = toString(nextStatus);
    var sortedCol = sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder;
    RescriptReactRouter.push("/tickets/manage/" + scopeParam + "?status=" + statusParam + "&page=1&sortedCol=" + sortedCol + "&sortOrder=" + sortOrder);
  };
  var applySort = function (param) {
    var scopeParam = scopeToString(state.scope);
    var sortedCol = sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder;
    RescriptReactRouter.push("/tickets/manage/" + scopeParam + "?status=" + workflowStatusParam + "&page=1&sortedCol=" + sortedCol + "&sortOrder=" + sortOrder);
    Curry._1(dispatch, "Loading");
    Js_promise.then_((function (param) {
            var ticketDetails = param[0];
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            return Promise.resolve(Curry._1(dispatch, {
                            TAG: "DisplayList",
                            _0: ticketDetails[0],
                            _1: ticketDetails[1]
                          }));
          }), fetchTicketDetails());
  };
  var selectedScope = function (param) {
    var scopeParam = scopeToString(state.scope);
    if (scopeParam === "all") {
      return "All Tickets";
    } else {
      return scopeParam;
    }
  };
  if (state.loading) {
    return JsxRuntime.jsx("p", {
                children: "Fetching tickets..."
              });
  }
  var emailText = function (assignee) {
    return Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.Assignee.email(assignee));
  };
  var assignee = state.form.selected;
  var selectedValue = assignee !== undefined ? emailText(assignee) : "";
  var isSomeTicketSelected = Belt_List.some(state.form.ticketStatuses, enabled);
  var isSelectionEmpty = Belt_Option.isNone(state.form.selected);
  var hasCustomHeaders = Belt_List.length(ticketHeaders) > 0;
  var effectiveColumnOrder = columnOrder.length === 0 ? TicketHeadersApi$ReactHooksTemplate.defaultColumnOrder(ticketHeaders) : columnOrder;
  var headerLabelForToken = function (token) {
    switch (token) {
      case "assignee" :
          return "Assignee";
      case "created_at" :
          return "Created At";
      case "id" :
          return "Id";
      case "priority" :
          return "Priority";
      case "status" :
          return "Status";
      default:
        if (!token.startsWith("df_")) {
          return token;
        }
        var rest = token.slice(3);
        var dfId = Belt_Int.fromString(rest);
        if (dfId !== undefined) {
          return Belt_Option.getWithDefault(Belt_Option.map(Belt_List.getBy(ticketHeaders, (function (h) {
                                return Caml_obj.equal(DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h)), dfId);
                              })), (function (h) {
                            return DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(h));
                          })), token);
        } else {
          return token;
        }
    }
  };
  var buildValuesByHeaderName = function (ticket) {
    var valuesByHeader = {};
    var headers = Ticket$ReactHooksTemplate.header(ticket);
    var contents = Ticket$ReactHooksTemplate.contents(ticket);
    Belt_Array.forEachWithIndex(headers, (function (i, headerName) {
            var x = Caml_array.get(contents, i);
            var value = x !== undefined ? x : "";
            valuesByHeader[headerName] = value;
          }));
    return valuesByHeader;
  };
  var selectionDisabledCSS = isSomeTicketSelected ? "" : "hidden";
  var submitButtonStatus = isSomeTicketSelected && !isSelectionEmpty;
  var submitDisabledCSS = submitButtonStatus ? "" : "hidden";
  var selectedTickets = Belt_List.map(Belt_List.keep(state.form.ticketStatuses, enabled), ticket);
  var postTicketAssignment = function (assignee) {
    if (selectedTickets) {
      Js_promise.then_((function (param) {
              return Promise.resolve((window.location.reload(), undefined));
            }), Js_promise.then_((function (response) {
                  return Promise.resolve((console.log(response), undefined));
                }), assignTicket(assignee, selectedTickets)));
      return ;
    }
    
  };
  var handleTicketAssignment = function (_event) {
    Belt_Option.mapWithDefault(state.form.selected, undefined, postTicketAssignment);
  };
  var handleUpdateScope = function (scope, _event) {
    Curry._1(dispatch, {
          TAG: "UpdateViewFilter",
          _0: scope
        });
    var scopeParam = scopeToString(scope);
    var sortedCol = sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder;
    RescriptReactRouter.push("/tickets/manage/" + scopeParam + "?status=" + workflowStatusParam + "&sortedCol=" + sortedCol + "&sortOrder=" + sortOrder);
    window.location.reload();
  };
  var ticketScope = function (scope) {
    switch (scope) {
      case "All" :
          return function (param) {
            return true;
          };
      case "Assigned" :
          return function (x) {
            return Belt_Option.isSome(Ticket$ReactHooksTemplate.assignee(x.ticket));
          };
      case "Unassigned" :
          return function (x) {
            return Belt_Option.isNone(Ticket$ReactHooksTemplate.assignee(x.ticket));
          };
      
    }
  };
  var scopeTicketStatus = function (xs) {
    return Belt_List.keep(xs, ticketScope(state.scope));
  };
  var total = Belt_List.length(state.form.ticketStatuses);
  var enabled$1 = Belt_List.length(Belt_List.keep(state.form.ticketStatuses, enabled));
  var isIndeterminate = enabled$1 > 0 && enabled$1 !== total;
  var partial_arg = state.form;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: (function (param) {
                            Curry._1(dispatch, "ToggleFilter");
                          }),
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Overview",
                                      className: "text-xl font-semibold"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n              shadow-inner flex rounded py-2 px-3 text-xs",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, "ToggleFilter");
                                                })
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-1 filter-white",
                                                      src: Image$ReactHooksTemplate.download
                                                    }),
                                                "Download"
                                              ],
                                              className: "bg-pigmentblue border border-gray-400\n                  flex rounded py-2 px-3 text-xs text-white",
                                              onClick: (function ($$event) {
                                                  $$event.preventDefault();
                                                  Js_promise.then_((function (file_name) {
                                                          return Promise.resolve((console.log(file_name), RescriptReactRouter.push("/tickets/downloadList")));
                                                        }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/tickets/download"));
                                                })
                                            })
                                      ],
                                      className: "flex gap-4"
                                    })
                              ],
                              className: "flex justify-between items-center border-b border-gray-300 px-30-px py-16-px"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "All",
                                      className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                        workflowStatus === "All" ? TicketStatusColors$ReactHooksTemplate.filterAllActiveClass : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                      ),
                                      onClick: (function (param) {
                                          return handleWorkflowStatusChange("All", param);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Open",
                                      className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                        workflowStatus === "Open" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Open") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                      ),
                                      onClick: (function (param) {
                                          return handleWorkflowStatusChange("Open", param);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Parked",
                                      className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                        workflowStatus === "Parked" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Parked") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                      ),
                                      onClick: (function (param) {
                                          return handleWorkflowStatusChange("Parked", param);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Resolved",
                                      className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                        workflowStatus === "Resolved" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Resolved") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                      ),
                                      onClick: (function (param) {
                                          return handleWorkflowStatusChange("Resolved", param);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Closed",
                                      className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                        workflowStatus === "Closed" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Closed") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                      ),
                                      onClick: (function (param) {
                                          return handleWorkflowStatusChange("Closed", param);
                                        })
                                    })
                              ],
                              className: "flex flex-wrap items-center gap-1 px-30-px py-3 border-b border-gray-200"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("p", {
                                                      children: selectedScope(),
                                                      className: "mr-5-px"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      src: Image$ReactHooksTemplate.caretDown
                                                    })
                                              ],
                                              className: "flex items-center text-sm font-normal\n                             capitalize justify-between cursor-pointer"
                                            }),
                                        JsxRuntime.jsxs("ul", {
                                              children: [
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "All Tickets",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white\n                                 rounded cursor-pointer",
                                                            onClick: (function (param) {
                                                                return handleUpdateScope("All", param);
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "Assigned",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white\n                                 rounded cursor-pointer",
                                                            onClick: (function (param) {
                                                                return handleUpdateScope("Assigned", param);
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx("div", {
                                                            children: "Unassigned",
                                                            className: "block p-10-px hover:bg-palatinateblue hover:text-white\n                                 rounded cursor-pointer",
                                                            onClick: (function (param) {
                                                                return handleUpdateScope("Unassigned", param);
                                                              })
                                                          }),
                                                      className: "hover:bg-gray-300"
                                                    })
                                              ],
                                              className: "dropdown-list shadow text-gray-800 text-sm"
                                            })
                                      ],
                                      className: "dropdown mr-20-px"
                                    }),
                                hasCustomHeaders ? null : JsxRuntime.jsxs("div", {
                                        children: [
                                          "No custom ticket headers configured. Showing default columns only. ",
                                          JsxRuntime.jsx("a", {
                                                children: "Configure headers",
                                                className: "underline hover:text-palatinateblue",
                                                href: "/tickets/tickets_headers"
                                              })
                                        ],
                                        className: "mx-6 text-xs text-aurometalsaurus"
                                      }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("select", {
                                              children: $$Array.of_list(List.map((function (assignee) {
                                                          return JsxRuntime.jsx("option", {
                                                                      children: emailText(assignee),
                                                                      value: emailText(assignee)
                                                                    }, String(Ticket$ReactHooksTemplate.Assignee.id(assignee)));
                                                        }), {
                                                        hd: Ticket$ReactHooksTemplate.Assignee.empty,
                                                        tl: state.form.assignees
                                                      })),
                                              className: selectionDisabledCSS + " block border px-3 py-2 border-gray-400\n                  w-52 bg-white rounded capitalize mr-6 text-sm",
                                              disabled: !isSomeTicketSelected,
                                              value: selectedValue,
                                              onChange: (function (param) {
                                                  var emailText = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, Utils$ReactHooksTemplate.formTargetValue(param));
                                                  if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, emailText)) {
                                                    return Curry._1(dispatch, {
                                                                TAG: "UpdateAssignee",
                                                                _0: undefined
                                                              });
                                                  }
                                                  var selected = List.find((function (assignee) {
                                                          return Caml_obj.equal(Ticket$ReactHooksTemplate.Assignee.email(assignee), emailText);
                                                        }), partial_arg.assignees);
                                                  return Curry._1(dispatch, {
                                                              TAG: "UpdateAssignee",
                                                              _0: selected
                                                            });
                                                })
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: "Assign Ticket",
                                              className: submitDisabledCSS + " bg-ghostwhite border border-gray-400 shadow-inner\n                  rounded py-2 px-3 text-sm hover:bg-palatinateblue hover:text-white",
                                              disabled: !submitButtonStatus,
                                              onClick: handleTicketAssignment
                                            })
                                      ],
                                      className: "flex items-center px-30-px"
                                    })
                              ],
                              className: "flex items-center py-30-px px-30-px"
                            }),
                        JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                              currentPage: currentPage,
                              totalPages: totalPagesCount,
                              totalRecords: totalCount,
                              perPage: perPageCount,
                              handlePageChange: handlePageChange,
                              itemLabel: "tickets",
                              className: "mx-30-px mb-4"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("table", {
                                          children: [
                                            JsxRuntime.jsx("thead", {
                                                  children: JsxRuntime.jsxs("tr", {
                                                        children: [
                                                          JsxRuntime.jsx("th", {
                                                                children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                      checked: state.form.selectAll,
                                                                      label: "",
                                                                      handleChange: (function (param) {
                                                                          Curry._1(dispatch, "ToggleSelectAll");
                                                                        }),
                                                                      indeterminate: isIndeterminate,
                                                                      checkboxClassName: "custom_checkbox"
                                                                    }),
                                                                className: "px-4"
                                                              }),
                                                          Belt_Array.map(effectiveColumnOrder, (function (token) {
                                                                  if (token === "created_at") {
                                                                    return JsxRuntime.jsxs("th", {
                                                                                children: [
                                                                                  JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          headerLabelForToken(token),
                                                                                          JsxRuntime.jsx("img", {
                                                                                                className: "ml-4-px sort-img",
                                                                                                src: Image$ReactHooksTemplate.heading
                                                                                              })
                                                                                        ],
                                                                                        className: "flex cursor-pointer",
                                                                                        onClick: (function (param) {
                                                                                            Curry._1(setOpenSortModal, (function (param) {
                                                                                                    return true;
                                                                                                  }));
                                                                                          })
                                                                                      }),
                                                                                  openSortModal ? JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx("div", {
                                                                                                  children: "Sort",
                                                                                                  className: "text-sm font-light text-aurometalsaurus"
                                                                                                }),
                                                                                            JsxRuntime.jsx("button", {
                                                                                                  children: "Sort by latest first",
                                                                                                  className: "w-48 flex flex-row justify-start items-center p-2 rounded " + (
                                                                                                    sortingInfo.sortedColumn !== "created_at" || sortingInfo.sortingOrder === "desc" ? "bg-lavenderweb border border-lavenderweb" : ""
                                                                                                  ),
                                                                                                  onClick: (function (param) {
                                                                                                      Curry._1(setSortingInfo, (function (param) {
                                                                                                              return {
                                                                                                                      sortedColumn: "created_at",
                                                                                                                      sortingOrder: "desc"
                                                                                                                    };
                                                                                                            }));
                                                                                                    })
                                                                                                }),
                                                                                            JsxRuntime.jsx("button", {
                                                                                                  children: "Sort by oldest first",
                                                                                                  className: "w-48 flex flex-row justify-start items-center p-2 rounded " + (
                                                                                                    sortingInfo.sortedColumn === "created_at" && sortingInfo.sortingOrder === "asc" ? "bg-lavenderweb border border-lavenderweb" : ""
                                                                                                  ),
                                                                                                  onClick: (function (param) {
                                                                                                      Curry._1(setSortingInfo, (function (param) {
                                                                                                              return {
                                                                                                                      sortedColumn: "created_at",
                                                                                                                      sortingOrder: "asc"
                                                                                                                    };
                                                                                                            }));
                                                                                                    })
                                                                                                }),
                                                                                            JsxRuntime.jsx("hr", {
                                                                                                  className: "border border-gray-200 w-full"
                                                                                                }),
                                                                                            JsxRuntime.jsxs("div", {
                                                                                                  children: [
                                                                                                    JsxRuntime.jsx("button", {
                                                                                                          children: "Cancel",
                                                                                                          className: "py-2 w-1/2 border border-gray-300 text-aurometalsaurus rounded",
                                                                                                          onClick: (function (param) {
                                                                                                              Curry._1(setOpenSortModal, (function (param) {
                                                                                                                      return false;
                                                                                                                    }));
                                                                                                            })
                                                                                                        }),
                                                                                                    JsxRuntime.jsx("button", {
                                                                                                          children: "Apply",
                                                                                                          className: "py-2 w-1/2 bg-pigmentblue text-white rounded",
                                                                                                          onClick: (function (param) {
                                                                                                              applySort();
                                                                                                              Curry._1(setOpenSortModal, (function (param) {
                                                                                                                      return false;
                                                                                                                    }));
                                                                                                            })
                                                                                                        })
                                                                                                  ],
                                                                                                  className: "flex justify-between w-full font-semibold text-sm gap-2"
                                                                                                })
                                                                                          ],
                                                                                          className: "flex border border-gray-400 rounded-lg shadow-md flex-col justify-start\n                      items-start gap-2 p-4 z-10 absolute bg-white sort-modal"
                                                                                        }) : null
                                                                                ],
                                                                                className: "px-4 py-2"
                                                                              });
                                                                  } else {
                                                                    return JsxRuntime.jsx("th", {
                                                                                children: JsxRuntime.jsxs("div", {
                                                                                      children: [
                                                                                        headerLabelForToken(token),
                                                                                        JsxRuntime.jsx("img", {
                                                                                              className: "ml-4-px",
                                                                                              src: Image$ReactHooksTemplate.heading
                                                                                            })
                                                                                      ],
                                                                                      className: "flex"
                                                                                    }),
                                                                                className: "px-4 py-2"
                                                                              });
                                                                  }
                                                                }))
                                                        ]
                                                      }),
                                                  className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                                }),
                                            JsxRuntime.jsx("tbody", {
                                                  children: Belt_List.toArray(Belt_List.map(scopeTicketStatus(state.form.ticketStatuses), (function (x) {
                                                              var ticket = x.ticket;
                                                              var valuesByHeader = buildValuesByHeaderName(ticket);
                                                              return JsxRuntime.jsxs("tr", {
                                                                          children: [
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                                        checked: x.enabled,
                                                                                        label: "",
                                                                                        handleChange: (function (param) {
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "ToggleTicketStatus",
                                                                                                  _0: x
                                                                                                });
                                                                                          }),
                                                                                        checkboxClassName: "custom_checkbox"
                                                                                      }),
                                                                                  className: "px-4 py-2"
                                                                                }),
                                                                            Belt_Array.map(effectiveColumnOrder, (function (token) {
                                                                                    var assignee = Ticket$ReactHooksTemplate.assignee(ticket);
                                                                                    var assigneeText = assignee !== undefined ? Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.Assignee.email(assignee)) : "Unassigned";
                                                                                    switch (token) {
                                                                                      case "assignee" :
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: assigneeText,
                                                                                                      className: "px-4 py-2"
                                                                                                    });
                                                                                      case "created_at" :
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: Ticket$ReactHooksTemplate.createdAt(ticket).format("lll"),
                                                                                                      className: "px-4 py-2"
                                                                                                    });
                                                                                      case "id" :
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: JsxRuntime.jsx("a", {
                                                                                                            children: String(Ticket$ReactHooksTemplate.id(ticket)),
                                                                                                            href: "/tickets/show/" + String(Ticket$ReactHooksTemplate.id(ticket))
                                                                                                          }),
                                                                                                      className: "px-4 py-2"
                                                                                                    });
                                                                                      case "priority" :
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: JsxRuntime.jsx("div", {
                                                                                                            children: TicketCategory$ReactHooksTemplate.name(Ticket$ReactHooksTemplate.ticketCategory(ticket)),
                                                                                                            className: "flex justify-center items-center font-normal border border-gray-300 rounded-2xl\n                  py-1 px-3 uppercase text-10-px ",
                                                                                                            style: {
                                                                                                              backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(TicketCategory$ReactHooksTemplate.color(Ticket$ReactHooksTemplate.ticketCategory(ticket)))
                                                                                                            }
                                                                                                          }),
                                                                                                      className: "px-4 py-2"
                                                                                                    });
                                                                                      case "status" :
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: JsxRuntime.jsxs("div", {
                                                                                                            children: [
                                                                                                              JsxRuntime.jsx("div", {
                                                                                                                    className: "h-3 w-3 rounded-full " + TicketStatusColors$ReactHooksTemplate.dotClass(Ticket$ReactHooksTemplate.status(ticket))
                                                                                                                  }),
                                                                                                              Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket))
                                                                                                            ],
                                                                                                            className: "text-10-px px-2 py-1 rounded-2xl flex gap-1 items-center\n                  border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                                                                          }),
                                                                                                      className: "px-4 py-2 uppercase"
                                                                                                    });
                                                                                      default:
                                                                                        if (!token.startsWith("df_")) {
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: "",
                                                                                                      className: "px-4 py-2"
                                                                                                    });
                                                                                        }
                                                                                        var text = Ticket$ReactHooksTemplate.customHeaderValue(ticket, token);
                                                                                        var fallbackText;
                                                                                        if (text === "") {
                                                                                          var rest = token.slice(3);
                                                                                          var dfId = Belt_Int.fromString(rest);
                                                                                          if (dfId !== undefined) {
                                                                                            var h = Belt_List.getBy(ticketHeaders, (function (h) {
                                                                                                    return Caml_obj.equal(DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h)), dfId);
                                                                                                  }));
                                                                                            fallbackText = h !== undefined ? Belt_Option.getWithDefault(Js_dict.get(valuesByHeader, DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(Caml_option.valFromOption(h)))), "") : "";
                                                                                          } else {
                                                                                            fallbackText = "";
                                                                                          }
                                                                                        } else {
                                                                                          fallbackText = text;
                                                                                        }
                                                                                        return JsxRuntime.jsx("td", {
                                                                                                    children: fallbackText,
                                                                                                    className: "px-4 py-2"
                                                                                                  });
                                                                                    }
                                                                                  }))
                                                                          ],
                                                                          className: "border-b border-bottom-gray-600"
                                                                        }, String(Ticket$ReactHooksTemplate.id(ticket)));
                                                            })))
                                                })
                                          ],
                                          className: "px-30-px text-left table-auto w-full border-separate text-xs font-medium"
                                        }),
                                    className: "pb-30-px w-full"
                                  }),
                              className: "flex overflow-auto w-full",
                              style: {
                                height: "calc(100vh - 16rem)"
                              }
                            })
                      ]
                    })
              ]
            });
}

var make = TicketManager;

exports.fetchTickets = fetchTickets;
exports.fetchTicketWorkers = fetchTicketWorkers;
exports.TicketStatus = TicketStatus;
exports.emptyForm = emptyForm;
exports.reducer = reducer;
exports.assignTicket = assignTicket;
exports.scopeFromString = scopeFromString;
exports.scopeToString = scopeToString;
exports.WorkflowStatus = WorkflowStatus;
exports.fetchTicketDetails = fetchTicketDetails;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.s = s;
exports.make = make;
/* react Not a pure module */
